import useGetActorSummary from "../../../hooks/useGetActorSummary";
import {
  Icon,
  KeyValueList,
  NoData,
  RenderWhen,
  RLCard
} from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import ExpandableValue from "../ExpandableValue";
import { getCountryFromCountryCode } from "../utils";
import { ActorInsightsProps } from "../../../@types/actor";
import styles from "../ioc.module.scss";

interface ActorInsightsWithDescription extends ActorInsightsProps {
  description?: string;
}
const ActorInsights = ({
  actorName,
  description
}: ActorInsightsWithDescription) => {
  const { data: actorData } = useGetActorSummary(actorName || "");

  const aliases = actorData?.aliases?.join(", ");
  const tactics = actorData?.ttps?.map(tactic => tactic.name).join(", ");
  const countryCode = actorData?.state_attribution?.country;
  const countryName = getCountryFromCountryCode(countryCode);

  const actorImageUrl = `${
    window.tcbase.urls.static
  }images/actor_images/${actorName?.replaceAll(" ", "").toLowerCase()}.jpg`;

  return (
    <RLCard
      header={
        <RLCard.Header>
          <div className="flex flex-center flex-gap-2">
            <span>Actor Insights: {actorName}</span>
            <AIGeneratedIcon />
          </div>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <div className={styles.actor_insights_layout}>
            <div className={styles.actor_insights_details}>
              <RenderWhen condition={!!description}>
                <p className="mb-10">{description}</p>
              </RenderWhen>
              <KeyValueList className={styles.ioc_key_value_entry}>
                <KeyValueList.Item
                  label="Actor Aliases: "
                  value={
                    <ExpandableValue value={aliases} fallback={<NoData />} />
                  }
                />
                <KeyValueList.Item
                  label="Country: "
                  value={
                    countryName ? (
                      <span className="inline-flex">
                        {countryCode && (
                          <Icon
                            name={countryCode.toLowerCase()}
                            flag
                            className="me-5"
                          />
                        )}
                        {countryName}
                      </span>
                    ) : (
                      <NoData />
                    )
                  }
                />
                <KeyValueList.Item
                  label="Group Type: "
                  value={actorData?.actor_type || <NoData />}
                />
                <KeyValueList.Item
                  label="Known Tactics: "
                  value={
                    <ExpandableValue value={tactics} fallback={<NoData />} />
                  }
                />
              </KeyValueList>
            </div>
            <div className={styles.actor_image_container}>
              <img
                className={styles.actor_image}
                src={actorImageUrl}
                alt={`${actorName} actor`}
                onError={e => {
                  const target = e.currentTarget;
                  if (target.src.includes("placeholder")) {
                    return;
                  }
                  target.src = `${window.tcbase.urls.static}images/actor_images/placeholder.jpg`;
                }}
              />
            </div>
          </div>
        </RLCard.Content>
      }
    />
  );
};

export default ActorInsights;
